import ModuleHelper, { moduleKey } from "../../app/User/Helper/ModuleHelper"


class InventoryHelper {
    getOutOfStockInfo(orders) {
        return orders.map(order => {
            let remainingQuantity = this.getRemainingQuantity(order.getMenuItem())
            return {
                id: order.id,
                isOutOfStock: remainingQuantity < 0,
                remainingQuantity: remainingQuantity,
            }
        }).filter(order => order.isOutOfStock)
    }
    getRemainingQuantity = (menuItem) => {
        let remainingQuantity = 999 // Default we set to some large positive number
        if (menuItem && menuItem.track_inventory && ModuleHelper.moduleEnabled(moduleKey.INVENTORY)) {
            // If has inventory tracking, get remaining quantity
            remainingQuantity = menuItem.getInventoryRemainingQuantity()
        }
        return remainingQuantity
    }
}

export default InventoryHelper